<template lang="html">

  <section class="cover-popup row-center" v-if="encuestasObligatorias.length != 0 && $route.name != 'ficha'">
    <div class="popup column-center">
      <h2 v-html="$t('encuestas_obligatorias')"></h2>
      <p v-html="$t('por_favor_responda')"></p>
      <div class="encuesta-el" :style="styles.bgbody" v-for="el in encuestasObligatorias">
        <h2 class="titulo" :style="styles.colorBasic">{{el.titulo}}</h2>
        <arrow-link :text="$t('comenzar')" :external="true" :to="brand.dominioEncuesta+el.urlAcceso" :blank="false">
        </arrow-link>

        <h3  :style="styles.colorBasic" v-if="el.nombrePractica || el.nombreEstudiante">{{el.nombrePractica}} - {{el.nombreEstudiante}}</h3>
        <arrow-link v-if="el.idPractica" :text="$t('ver_practica_relacionada')" :external="true" :to="$t('enlaces.ficha')+'/'+el.idPractica" :blank="true"></arrow-link>
      </div>

      <p>{{$t('si_no_deseas')}} <a @click="logout">{{$t('pincha_aqui')}}</a></p>

    </div>
  </section>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import arrowlink from '@/components/parts/icons/arrow-link';

  export default {
    name: 'popup-encuestas-obligatorias',
    mounted() {
      setTimeout(e => {
        this.requestEncuestas().then(r => {
          this.data = r;
        })
      }, 200)
    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        encuestas: 'getEncuestas',
        brand: 'getBrand'
      }),
      encuestasObligatorias() {
        if (!!this.encuestas) {
          return this.encuestas.filter(e => e.respuestaObligatoria);
        }
      }
    },
    methods: {
      ...mapActions(['requestEncuestas','logout'])
    },
    components: {
      'arrow-link': arrowlink,
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/css/colors.scss';


  .btn {
    margin-top: 30px;
  }

  h2 {
    text-align: left;
    width: 100%;
    color: #4a4a4a;
    font-weight: bold;
  }

  p {
    margin-bottom: 20px;
    text-align: left;
    width: 100%;
    color: #4a4a4a;
    a{
      text-decoration: underline;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-encuestas-obligatorias.vue